// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5f16463e","455":"be57abfb","977":"9a0bce34"}[chunkId] + ".chunk.js";
};